import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Toaster } from '../ui/sonner';

const Layout = ({ children, showFooter = true }) => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="container mx-auto px-4 py-6 md:py-8 flex-grow">
        {children}
      </main>
      {showFooter && <Footer />}
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default Layout;
